<template>
    <div class="login-content" style="height: 100%">
        <div style="height: 20%"></div>
        <div class="login">
            <h1 class="title">光伏云智能监控平台</h1>
            <div class="desc">{{copyright.content}}</div>
            <a-form :form="form" @submit="handleSubmit">
                <a-row :gutter="12">
                    <a-form-item label="用户名" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-input
                                v-decorator="['username', { rules: [{ required: true, message: '请输入用户名' }] }]"
                        />
                    </a-form-item>
                    <a-form-item label="密码" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-input-password
                                v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] }]"
                        />
                    </a-form-item>
                    <a-form-item :wrapper-col="{ span: 16, offset: 6 }">
                        <a-button  type="primary" html-type="submit" block :loading="state.loginBtn"
                                   :disabled="state.loginBtn">
                            登录
                        </a-button>
                    </a-form-item>
                </a-row>
            </a-form>

        </div>

        <div class="copyright">{{copyright.copyright}}</div>

    </div>
</template>

<script>
    import md5 from 'js-md5'
    import basicRouter from "@/router/basicRouter"
    import groupRouter from "@/router/groupRouter";
    import stationRouter from "@/router/stationRouter"
    import adminRouter from "../router/adminRouter";
    export default {
        name: "Login",
        data() {
            return {
                formLayout: 'horizontal',
                loginBtn: false,
                form: this.$form.createForm(this),
                state: {
                    time: 60,
                    loginBtn: false,
                    // login type: 0 email, 1 username, 2 telephone
                    loginType: 0,
                    smsSendBtn: false
                },
                copyright:{
                    copyright: '',
                    content: ''
                }
            };
        },
        mounted(){
          console.log('login')
            this.loadCopyright();
        },
        methods: {

            async loadCopyright(){
                let result = await this.$http.get(this.$baseURL.copyright());
                this.copyright.copyright = result.name;
                this.copyright.content = result.content;
            },
            handleSubmit(e) {
                e.preventDefault();
                const { form: { validateFields }, state, customActiveKey, Login } = this;
                state.loginBtn = true;
                validateFields(["username","password"], { force: true }, (err, values) => {
                    if (!err) {
                        let loginParams = { ...values }
                        console.log(loginParams)
                        loginParams.password = md5(loginParams.password);
                        this.login(loginParams)

                    } else {
                        setTimeout(() => {
                            state.loginBtn = false
                        }, 600)
                    }
                })
            },
            async login(data){
                let getTokenParams = {...data, ...this.$baseURL.secret};
                let token = await this.$http.post(this.$baseURL.token(), getTokenParams);
                this.$Utils.setCookie('secret', token);
                let result = await this.$http.post(this.$baseURL.login(), data, 1);
                console.log(result)
                if (result.code === 0){
                    this.$Utils.setStorage('user', result.data);
                    this.loadUserRouter(result.data);
                    this.$router.push({path: '/'})
                } else {
                    this.$message.error(result.msg);
                }
                this.state.loginBtn = false;

                console.log(555)

                this.$websocketclient.connect(this.$Utils.getUserStorage())

            },
            loadUserRouter(data){
                let roleId = data.roleId;
                let result = basicRouter;
                if(roleId === 3){
                    result = result.concat(stationRouter);
                } else if(roleId === 2) {
                    result = result.concat(groupRouter);
                } else if(roleId === 1) {
                    result = result.concat(adminRouter);
                }
                this.$router.options.routes = result;
                this.$router.addRoutes(result)

            }

        },
    }
</script>

<style lang="scss" scoped>


    .login-content{
        background: #f0f2f5 url(/login-gb.svg) no-repeat 50%;
        background-size: 100%;
    }

    .login {
        width: 500px;
        margin: 0 auto;
        padding: 30px 10px 10px 10px;
        border: 1px solid #dfdfdf;
        border-radius: 5px;
        box-shadow: 5px 5px 5px #d4d4d4;
        background: #fff;

        .title {
            text-align: center;
        }

        .desc{
            text-align: center;
            margin-bottom: 30px;
            margin-top: 20px;
            padding: 10px;
        }
    }

    .copyright{
        position: absolute;
        bottom: 30px;
        width: 100%;
        text-align: center;
    }

</style>
